import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DashboardOutlined, TeamOutlined, ScheduleOutlined, FileTextOutlined, CheckCircleOutlined, BookOutlined } from '@ant-design/icons';
import MainLayout from '../components/MainLayout';
import { useSettings } from '../context/SettingsContext';

const MentorLayout = ({ children, user }) => {
    const { t } = useTranslation();
    const { settings } = useSettings();

    const generateMentorMenu = useCallback((closeMobileDrawer) => {
        const modules = settings?.modules_enabled || {};
        const isEnabled = (moduleKey) => modules[moduleKey] !== false;

        const createMenuItem = (key, icon, label, moduleKey) => {
            return {
                key, icon, label: <Link to={key} onClick={closeMobileDrawer}>{label}</Link>
            };
        };

        const createSubMenu = (key, icon, label, children) => {
            if (!children || children.length === 0) return null;
            return { key, icon, label, children };
        };

        const items = [];

        items.push(createMenuItem('/', <DashboardOutlined />, t('common.dashboard'), 'dashboard'));

        const myStudentsItems = [];
        if (isEnabled('students')) myStudentsItems.push(createMenuItem('/students', <TeamOutlined />, 'My Mentees', 'students'));
        if (isEnabled('attendance')) myStudentsItems.push(createMenuItem('/attendance', <CheckCircleOutlined />, 'Mentee Attendance', 'attendance'));
        if (isEnabled('marks')) myStudentsItems.push(createMenuItem('/marks', <BookOutlined />, 'Mentee Marks', 'marks'));

        items.push(createSubMenu('mentor-mgmt', <TeamOutlined />, 'Mentorship', myStudentsItems));

        items.push({ type: 'divider' });

        if (isEnabled('calendar')) items.push(createMenuItem('/calendar', <ScheduleOutlined />, t('menu.schoolCalendar'), 'calendar'));
        if (isEnabled('reports')) items.push(createMenuItem('/reports', <FileTextOutlined />, t('menu.reports'), 'reports'));

        return items;

    }, [settings, t]);

    return (
        <MainLayout customMenuGenerator={generateMentorMenu}>
            {children}
        </MainLayout>
    );
};

export default MentorLayout;
